<template>
  <div class="newhand">
    <!-- 文案 -->
    <div class="newhand-text">
      <div class="newhand-bg"></div>
      <div class="warper clearfix">
        <a-breadcrumb>
          <a-breadcrumb-item
            >
                <i class="iconfont icon-menu-home" style="color: #fff;margin-right:5px"></i>
            <a href="/help/" style="color: #fff">帮助中心</a></a-breadcrumb-item
          >
          <a-breadcrumb-item style="color: #fff"
            >极速智能配置</a-breadcrumb-item
          >
        </a-breadcrumb>
        <h1 style="color: #fff">极速智能配置</h1>
        <p>
          通过云基于整网的智能助力用户在每个项目中通过匹配项目的最佳配置来为最终业主提供稳定、好体验的网络。
        </p>
      </div>
    </div>
    <!-- 极速智能配置的初衷 -->
    <div class="warper clearfix">
      <div class="h1box">
        <h1>极速智能配置的初衷</h1>
        <div class="borderline"></div>
      </div>
      <a-row style="padding-bottom:2rem">
        <a-col :span="8"><img src="@/assets/icon/js_img.png"/></a-col>
        <a-col :span="16" style="padding-left:2rem">
          <h2 class="content_h2">场景描述</h2>
          <p>
            <li>
              案例1：你是否曾经在项目中因为环路导致现场网络故障，不得不去现场一个个端口拔网线排查？
            </li>
          </p>
          <p>
            <li>
              案例2：你可曾收到用户上网卡顿或网速慢的抱怨？到现场排查半天发现是有人用手机在下载视频/看直播
              占用了大量带宽?
            </li>
          </p>
          <h2 class="content_h2">案例分析</h2>
          <p>
            上述案例1和案例2都来自真实的工程商用户。大家可能会把这些归属到售后故障支持，但是，有经验的工程商会在工作做在前头
            ---
            项目调试配置的环节。对于案例1提到的环路，他会在项目开局的时候，开启整网防环路，这样现场一旦出现网线误接出现环路，防环功能会将其中一个端口Down，并且通过"锐捷诺客云"或者睿易APP收到告警。对于案例2，他会在项目中，将主要用于办公的有线PC和用于手机休闲娱乐的无线WiFi划分到不同的VLAN（网段），之后对有线PC网段进行带宽保障，对无线WiFi进行限速。所以，
            <span style="font-weight: 500;color:#000000"
              >品质、性能过硬的硬件设备是好网络的基础，匹配项目的"好配置"更是为业主提供一张好网络的有效保障。</span
            >
          </p>
        </a-col>
      </a-row>
    </div>
    <!-- 极速智能配置总览 -->

    <div class="secondBox">
      <div class="warper clearfix">
        <div class="h1box">
          <h1>极速智能配置总览</h1>
          <p>
            极速智能配置，基于整网和云的智能，将复杂的部分由云来计算，将简单给到您。
          </p>
        </div>
        <a-row type="flex" justify="space-between" align="middle">
          <a-col :span="9">
            <div class="card">
              <div class="card-title">
                <img src="@/assets/icon/h2_bg02.png" alt="" />
                <h2>配置</h2>
              </div>
              <div class="card-content">
                <div>
                  <span class="card-content-h">终端接入</span>
                </div>
                <div class="line">
                  <span class="card-content-p"
                    ><p>有线/无线业务网(划VLAN)</p></span
                  >
                  <span class="card-content-p"><p>业务访问控制(ACL)</p></span>
                </div>
                <div style="margin-top: 2rem;">
                  <span class="card-content-h">设备内网环节</span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>AP管理VLAN</p></span>
                  <span class="card-content-p disable"
                    ><p>交换机管理IP配置（尚未发布）</p></span
                  >
                </div>
                <div style="margin-top: 2rem;">
                  <span class="card-content-h">出口环节</span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>多出口配置</p></span>
                  <span class="card-content-p"><p>出口LAN/WAN转换</p></span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>专线配置</p></span>
                  <span class="card-content-p"><p>策略路由</p></span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col
            ><svg
              width="50"
              height="40"
              viewBox="0 0 50 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 12.75C1 11.6454 1.89543 10.75 3 10.75H21.8462C22.9507 10.75 23.8462 9.85457 23.8462 8.75V3.17081C23.8462 1.49213 25.7894 0.560305 27.0983 1.61131L48.0578 18.4405C49.0549 19.2411 49.0549 20.7589 48.0578 21.5595L27.0983 38.3887C25.7894 39.4397 23.8462 38.5079 23.8462 36.8292V31.25C23.8462 30.1454 22.9507 29.25 21.8462 29.25H3C1.89543 29.25 1 28.3546 1 27.25V12.75Z"
                stroke="#A6C9FF"
                stroke-width="2"
              />
            </svg>
          </a-col>
          <a-col :span="6"
            ><div class="card">
              <div class="card-title">
                <img src="@/assets/icon/h2_bg02.png" alt="" />
                <h2>调优</h2>
              </div>
              <div class="card-content">
                <div>
                  <span class="card-content-h">终端接入</span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>无线智能优化(WIO)</p></span>
                </div>
                <div style="margin-top: 2rem;">
                  <span class="card-content-h">设备内网环节</span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>防环路</p></span>
                  <span class="card-content-p"><p>防私接</p></span>
                </div>
                <div class="line">
                  <span class="card-content-p"><p>防网关ARP欺骗</p></span>
                </div>
              </div>
            </div></a-col
          >
          <a-col
            ><svg
              width="50"
              height="40"
              viewBox="0 0 50 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 12.75C1 11.6454 1.89543 10.75 3 10.75H21.8462C22.9507 10.75 23.8462 9.85457 23.8462 8.75V3.17081C23.8462 1.49213 25.7894 0.560305 27.0983 1.61131L48.0578 18.4405C49.0549 19.2411 49.0549 20.7589 48.0578 21.5595L27.0983 38.3887C25.7894 39.4397 23.8462 38.5079 23.8462 36.8292V31.25C23.8462 30.1454 22.9507 29.25 21.8462 29.25H3C1.89543 29.25 1 28.3546 1 27.25V12.75Z"
                stroke="#A6C9FF"
                stroke-width="2"
              />
            </svg>
          </a-col>
          <a-col :span="6"
            ><div class="card">
              <div class="card-title">
                <img src="@/assets/icon/h2_bg02.png" alt="" />
                <h2>交付</h2>
              </div>
              <div class="card-content">
                <div>
                  <div class="card-content-box"><span>网络智检</span></div>
                </div>
                <div>
                  <div class="card-content-box"><span>交付报告</span></div>
                </div>
              </div>
            </div></a-col
          >
        </a-row>
      </div>
    </div>

    <!-- 极速智能配置之“业务网” -->
    <div class="warper clearfix">
      <div class="h1box" style="margin-bottom:0rem">
        <h1>极速智能配置之“业务网”</h1>
      </div>
      <a-tabs class="Atabs" v-model:activeKey="activeKey">
        <a-tab-pane key="Atabs01">
          <template #tab>
            <span style="color:rgba(0, 0, 0, 0.65);font-size: 18px;">
              适合场景
            </span>
          </template>
          <a-row type="flex" justify="space-around" align="middle">
            <a-col :span="16" style="padding-right:2rem">
              <div style="margin-top:1rem">
                <h2 class="content_Num">
                  <img src="@/assets/icon/h2_bg.png" alt="" /><span>1</span>
                  <p style="font-size: 16px;">隔离广播域</p>
                </h2>
                <div style="padding-left: 60px;">
                  <p>减少广播报文占用带宽，减少广播风暴。</p>
                  <p style="font-weight: 500;color:#000">广播报文有哪些：</p>
                  <p>
                    ①
                    网络终端发现设备、请求IP地址的ARP、DHCP请求报文都是广播报文。终端数据多的情况下，广播报文就会相应多。
                  </p>
                  <p>
                    ②
                    摄像头、门禁、广播系统等，设备发现通常也会采用广播或者组播报文(不支持组播的设备，会将组播报文按广播处理)，这类终端多的话，广播报文也会多。
                  </p>
                  <p style="font-weight: 500;color:#000">
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-right:0.3rem"
                    ></i
                    >企业办公门禁、监控
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-left:1rem;margin-right:0.3rem"
                    ></i
                    >酒店监控、IPTV
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-left:1rem;margin-right:0.3rem"
                    ></i
                    >中小学监控
                  </p>
                  <p style="font-weight: 500;color:#000">
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-right:0.3rem"
                    ></i
                    >小区/地产监控、可视门禁、道闸、广播等不同类终端隔离开
                  </p>
                </div>
              </div>
              <div style="margin-top:1rem">
                <h2 class="content_Num">
                  <img src="@/assets/icon/h2_bg.png" alt="" /><span>2</span>
                  <p style="font-size: 16px;">方便管理</p>
                </h2>
                <div style="padding-left: 60px;">
                  <p>
                    按照不同的部门进行 VLAN
                    划分，方便对不同的职能部门配置策略，做一些限制等等，一定程度上保证内网安全，更好地管理企业内网。
                  </p>
                  <p>
                    针对不同的业务网有不同的策略的情况。
                  </p>
                  <p>
                    例如，酒店场景，可能存在住客上网、会议室宴会网络、前台办公网络、监控网络等。前台办公网络，涉及入住/退费办理，需要有更高可靠性。
                    又如，企业办公，不同部门访问内网的权限可能有差别、安全要求不同，需要划分不同的VLAN，并在此基础上结合ACL设置互访权限。
                  </p>
                  <p style="font-weight: 500;color:#000">
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-right:0.3rem"
                    ></i
                    >企业办公不同部门：财务、普通员工、IT、服务器

                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-left:1rem;margin-right:0.3rem"
                    ></i
                    >酒店前台办公 住客
                  </p>
                </div>
              </div>
              <div style="margin-top:1rem">
                <h2 class="content_Num">
                  <img src="@/assets/icon/h2_bg.png" alt="" /><span>3</span>
                  <p style="font-size: 16px;">内网安全</p>
                </h2>
                <div style="padding-left: 60px;">
                  <p>
                    ①
                    同一VLAN下，如果有心人在这个网络中通过工具随便抓些包，就能获取整个网络里面的设备信息，进而对网络中其他设备造成安全威胁，非法窃取数据。划分
                    VLAN 之后，即便是出现这种情况，也能够将广播限制在当前 VLAN
                    内，不至于蔓延到整个公司内网。
                    例如，企业办公场景，单独划分一个访客VLAN，可以大大降低访客对内网的安全威胁。
                  </p>
                  <p>
                    ②
                    一些病毒软件，通过广播扫码发现同VLAN的其他设备，传播到同VLAN下的其他设备上。通过划VLAN也可以将这类病毒软件的传播范围控制在同一个VLAN内。
                    例如，中小学场景，将老师上网和教学设备上网划到不同VLAN，避免个别老师电脑的病毒传播到教学设备上。
                  </p>
                  <p style="font-weight: 500;color:#000">
                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-right:0.3rem"
                    ></i
                    >企业办公访客单独不同部门隔开

                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-left:1rem;margin-right:0.3rem"
                    ></i
                    >酒店前台办公单独

                    <i
                      class="iconfont icon-online"
                      style="color:#08B30C;margin-left:1rem;margin-right:0.3rem"
                    ></i
                    >小区/中小学老师上网与教学设备分开
                  </p>
                </div>
              </div>
            </a-col>
            <a-col :span="8">
              <img
                src="@/assets/icon/top02.gif"
                alt=""
                style="width: 414px;height: 232px;margin-bottom:2rem"
              />
              <img
                src="@/assets/icon/top01.gif"
                alt=""
                style="width: 414px;height: 232px;"
              />
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="Atabs02">
          <template #tab>
            <span style="color:rgba(0, 0, 0, 0.65);font-size: 18px;">
              基本原理
            </span>
          </template>
          <a-row style="margin-top:1rem">
            <div style="padding-bottom:2rem">
              <p style="color: rgba(0, 0, 0, 0.9);font-size:16px;">
                极速智能配置分为 <span style="color:#000;font-weight:600;">有线和无线</span> 两种，将复杂易错的配置切换成“下一步”式的半自动化配置。
              </p>
              <div style="padding-left:1rem">
              <li style="list-style-type:disc;list-style-position:inside;">
                  “有线业务网”配置包含划VLAN、DHCP、默认网关和应用设备与接口（如果一个接口应用多个业务网即trunk口，单个业务网即access口）。
                </li>
              <li style="list-style-type:disc;list-style-position:inside;">
                “无线业务网”除了上述部分，增加了无线名称等无线相关配置，并自动在AP上联的交换机接口配置trunk放通新的业务网VLAN。
                </li>
                </div>
            </div>
              <img
                src="@/assets/icon/top03.png"
            />
          <!-- <a-row style="margin-top:1rem">
            <a-col :span="16" style="padding-right:2rem">
              <p style="color: rgba(0, 0, 0, 0.9);font-weight:600;">
                极速智能配置的"划VLAN"，是广义的划VLAN，包含了多个子配置项。
              </p>
              <p style="color:#000;font-weight:500;">
                对于有线VLAN（我们称之为"有线业务网"），包含如下子配置项
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  DHCP地址池（可选：对于终端IP均采用静态IP的情况，DHCP地址池可以关闭）
                </li>
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  根据默认网关/DHCP地址池所在位置：
                </li>
              </p>
              <div style="padding-left:1rem">
                <p> >  默认网关/DHCP地址池在网关的情况（即：单臂路由），包含如下配置项:</p>
                <p style="padding-left:1rem">① 网关的子接口 <span style="color:#2B6AFD"> [云自动配置]</span></p>
                <p> > 默认网关/DHCP地址池在核心交换机的情况（即：三层网络），还包含：</p>
                <p style="padding-left:1rem">① 核心交换机的IP地址转静态 <span style="color:#2B6AFD">[云自动配置]</span></p>
                <p style="padding-left:1rem">② 网关上的回指路由 <span style="color:#2B6AFD">[云自动配置]</span></p>
                <p style="padding-left:1rem">
                  ③
                  核心交换机的IP地址，在网关上配置为“不分配IP”(也叫"排除IP")，不会再被分配给其他设备或者终端
                  <span style="color:#2B6AFD">[云自动配置]</span>
                </p>
              </div>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  整个各个交换机上的VLAN配置 <span style="color:#2B6AFD">[云自动配置]</span>
                </li>
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  各个交换机互联接口打trunk <span style="color:#2B6AFD">[云自动配置]</span>
                </li>
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  终端接入端口的VLAN配置 <span style="color:#2B6AFD">[用户选择接入端口，云自动配置]</span>
                </li>
              </p>
              <p style="color: #000;font-weight:500;">
                对于无线VLAN（我们称之为"无线业务网"），包含如下子配置项
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  DHCP地址池、默认网关、整个各个交换机上的VLAN配置、各个交换机互联接口打trunk，同有线VLAN。
                </li>
              </p>
              <p>
                <li style="list-style-type:disc;list-style-position:inside;">
                  无线SSID等相关配置
                </li>
              </p>

              <p>
                <li style="list-style-type:disc;list-style-position:inside">
                  无线AP上联的交换机端口自动打trunk <span style="color:#2B6AFD">[云自动配置]</span>
                </li>
              </p>
              <p>
                在简单的背后，是云在掌握整网拓扑的基础上，对上述各种复杂、容易出错的子配置的自动配置。
              </p>
            </a-col>
            <a-col :span="8">
              <img
                src="@/assets/icon/top03.png"
                style="width: 400px;height: 661px;"
            />
            </a-col> -->
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeKey: "Atabs01",
    };
  },
  methods: {
    goUrl() {
      this.$router.push({ name: "releaseArticle", query: { id: 302 } });
    },
  },
};
</script>
<style scoped>
::v-deep .ant-breadcrumb-separator {
  color: #fff;
}
h1,
h2 {
  font-weight: 500;
}
/* newhand */
.newhand {
  min-height: 100vh;
  padding-top: 68px;
  position: relative;
}
.newhand-text {
  position: relative;
  padding-top: 2vh;
  padding-bottom: 2rem;
  color: #fff;
}
.newhand-bg {
  background: url("../assets/icon/js_bg02.png") center no-repeat;
  background-size: cover;
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
}

.newhand-text h1 {
  margin-top: 1rem;
  text-align: center;
  font-weight: 500;
  font-size: 2rem;
}
.newhand-text p {
  text-align: center;
  font-size: 14px;
}

.h1box {
  text-align: center;
  margin: 2rem;
}
.h1box h1 {
  font-weight: 500;
  font-size: 24px;
  color: #000;
}
.h1box .borderline {
  margin: 0 auto;
  background: #2b6afd;
  border-radius: 9px;
  width: 40px;
  height: 7px;
}

.content_h2 {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
}

.content_Num {
  color: #fff;
  position: relative;
  height: 3rem;
}
.content_Num img {
  position: absolute;
  z-index: -1;
}
.content_Num span {
  position: absolute;
  font-size: 1.8rem;
  left: 15px;
}
.content_Num p {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  position: absolute;
  left: 60px;
  top: 10px;
}

.secondBox {
  background: #f7f9fd;
  /* width: 100vw; */
  padding-bottom: 2rem;
}
.card {
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(67, 129, 249, 0.1);
  border-radius: 8px;
}
.card-title {
  height: 4rem;
}
.card-title h2 {
  z-index: 999;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  z-index: 999;
  position: absolute;
  top: 30px;
  left: 20px;
}
.card-title img {
  top: 24px;
  left: -20px;
  position: absolute;
}
.card-content {
  height: 24rem;
  box-sizing: content-box;
  padding: 1rem;
}
.card-content .line {
  height: 4rem;
  line-height: 4rem;
}
.card-content-h {
  color: #000;
  font-weight: 500;
  border-left: 4px solid #2b6afd;
  padding-left: 0.5rem;
}

.card-content-p {
  padding: 11px 5px;
  border: 2px solid #f0f7ff;
  border-radius: 47px;
  margin-right: 1.5rem;
}
.card-content-p p {
  display: inline-block;
  padding: 5px 10px;
  background: #f0f7ff;
  border-radius: 47px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  line-height: 22px;
}
.disable {
  border: 2px solid #f5f5f5;
}
.disable p {
  background: #f5f5f5;
}

.card-content-box {
  padding: 5px;
  border: 2px solid #f0f7ff;
  border-radius: 47px;
  width: 80%;
  margin: 1rem auto;
  text-align: center;
}
.card-content-box span {
  display: block;
  padding: 5px 10px;
  background: #f0f7ff;
  border-radius: 47px;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
}

.Atabs::v-deep .ant-tabs-bar {
  text-align: center;
  border: none;
}
</style>
